// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"40e8aa28","221":"40e8aa28","266":"40e8aa28","356":"8ea8734b","548":"40e8aa28","656":"8ea8734b"}[chunkId] + ".chunk.css";
};